// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"s3","link":"s4","linkText":"s5","linkIcon":"s6","isRental":"s7","active":"s8","synopsisAndButton":"s9","linkWrapper":"s-"};